export default __webpack_public_path__ + "static/media/affiliate.985ba21c.png";